// extracted by mini-css-extract-plugin
export default {"container":"ActionLinkTop_container__ApqrA","red":"ActionLinkTop_red__4Y0RO"};